import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from '@config/auth.config'
import Home from '@pages/Home'
import Login from '@pages/Login'
import AgentsManagement from '@pages/AgentsManagement'
import AuthStart from '@pages/AuthStart'
import AuthEnd from '@pages/AuthEnd'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { useTeams } from '@contexts/TeamsContext'
import Loader from '@components/Loader'

const App = () => {
  const msalInstance = new PublicClientApplication(msalConfig)
  const { isInitialized } = useTeams()

  // Afficher un loader pendant l'initialisation de Teams
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center h-screen bg-white dark:bg-gray-900">
        <Loader />
      </div>
    )
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/agents-management" element={<AgentsManagement />} />
          {/* Routes pour l'authentification Teams */}
          <Route path="/auth-start" element={<AuthStart />} />
          <Route path="/auth-end" element={<AuthEnd />} />
        </Routes>
      </Router>
    </MsalProvider>
  )
}

export default App
